module.exports = require("acorn-import-attributes");